import { Component, OnInit,Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-alta-demanda',
  templateUrl: './alta-demanda.component.html',
  styleUrls: ['./alta-demanda.component.scss']
})
export class AltaDemandaComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<AltaDemandaComponent>,

  ) { }

  ngOnInit() {
  }
  onNoClick(){
    this.dialogRef.close();
  }

}
